/* eslint-disable no-param-reassign */
import { IonReactRouter } from '@ionic/react-router'
import { ReactNode, useState, useTransition } from 'react'

const SuspenseRouter = ({ children, history }: { children: ReactNode; history: any }) => {
  const [isPending, startTransition] = useTransition()
  const [suspenseHistory] = useState(() => {
    const { push, replace, go } = history

    history.push = (...args: any[]) => {
      startTransition(() => {
        push.apply(history, args)
      })
    }
    history.replace = (...args: any[]) => {
      startTransition(() => {
        replace.apply(history, args)
      })
    }
    history.go = (...args: any[]) => {
      startTransition(() => {
        go.apply(history, args)
      })
    }

    return history
  })

  suspenseHistory.isPending = isPending

  return <IonReactRouter history={suspenseHistory}>{children}</IonReactRouter>
}

export default SuspenseRouter
